import React, { useState } from 'react';
import { Box, Paper, Typography, Card, CardContent, Button } from '@mui/material';
import SearchComponent from '../../components/Search/SearchComponent';

const DashboardBody = () => {
  const [searchResults, setSearchResults] = useState([]); // Stores API results
  const [selectedJob, setSelectedJob] = useState(null); // Stores selected job details
  const [showText, setShowText] = useState(false); // Track if job description should be displayed

  // Function to decode HTML entities in job text
  const decodeHtmlEntities = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const handleSearchAction = (data) => {
    if (data?.response?.[0]?.export?.result?.item) {
      setSearchResults(data.response[0].export.result.item);
      setSelectedJob(null); // Clear selected job when new results arrive
    } else {
      setSearchResults([]);
      setSelectedJob(null); // Clear job details if no results
    }
  };

  return (
    <Box sx={{ mt: 10, p: 3 }}>
      {/* Search Section - Horizontal Layout with space from header */}
      <Paper elevation={3} sx={{ p: 2, mt: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>Paramètres de Recherche</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
          <SearchComponent handleSearch={handleSearchAction} />
        </Box>
      </Paper>

      {/* Main Content - Results and Details */}
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {/* Left Section - Search Results */}
        <Box sx={{ width: '30%', p: 2, overflowY: 'auto' }}>
          {searchResults.length > 0 ? (
            searchResults.map((job, index) => (
              <Card
                key={index}
                sx={{ mb: 2, cursor: 'pointer', p: 2 }}
                onClick={() => {
                  setSelectedJob(job);
                  setShowText(false);
                }}
              >
                <CardContent>
                  <Typography variant="h6">{job.company}</Typography>
                  <Typography variant="body2" color="textSecondary">{job['company-address']}</Typography>
                  <Typography variant="body2">{job['job-category'].join(', ')}</Typography>
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">Aucun résultat trouvé.</Typography>
          )}
        </Box>

        {/* Right Section - Job Details */}
        <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
          {selectedJob && searchResults.length > 0 ? (
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5">{selectedJob.position}</Typography>
              <Typography variant="subtitle1" color="primary">{selectedJob.company}</Typography>
              <Typography variant="body2" color="textSecondary">
                {selectedJob['company-address']}, {selectedJob['company-city']}
              </Typography>
              <Typography variant="body2">Catégorie: {selectedJob['job-category'].join(', ')}</Typography>
              <Typography variant="body2">Niveau de carrière: {selectedJob['career-level']}</Typography>
              <Typography variant="body2">Téléphone: {selectedJob['company-phone'] || 'Non disponible'}</Typography>
              <Typography variant="body2">Email: {selectedJob['company-email'] || 'Non disponible'}</Typography>

              {/* External Links */}
              <Box sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  href={selectedJob.link}
                  target="_blank"
                  sx={{ mr: 2 }}
                >
                  Voir l'annonce
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  href={selectedJob['company-link']}
                  target="_blank"
                >
                  Profil Entreprise
                </Button>
              </Box>

              {/* Show Full Job Description Button */}
              <Button
                variant="text"
                color="primary"
                onClick={() => setShowText(!showText)}
                sx={{ mt: 2 }}
              >
                {showText ? "Voir moins" : "Voir plus"}
              </Button>

              {/* Job Description */}
              {showText && (
                <Typography variant="body2" sx={{ mt: 2, whiteSpace: 'pre-wrap' }}>
                  {decodeHtmlEntities(selectedJob.text)}
                </Typography>
              )}
            </Paper>
          ) : searchResults.length === 0 ? null : (
            <Typography variant="h6" color="textSecondary" sx={{ textAlign: 'center', mt: 5 }}>
              Sélectionnez une annonce pour voir les détails.
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardBody;